import { render, staticRenderFns } from "./my_coll_teacher.vue?vue&type=template&id=66ffeae4&scoped=true"
import script from "./my_coll_teacher.vue?vue&type=script&lang=js"
export * from "./my_coll_teacher.vue?vue&type=script&lang=js"
import style0 from "./my_coll_teacher.vue?vue&type=style&index=0&id=66ffeae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ffeae4",
  null
  
)

export default component.exports